export const productName = 'INDUSTRIAL MAINTENANCE TEACHER READY';
export const productShortName = 'Industrial Maintenance Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/6LrzAPzzGvQmsDsLNDNm1K/MOCKUP.png';

export const checkoutUrl = 'https://industrial-maintenance-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Industrial Maintenance Fundamentals',
  'Volume 2 — Mechanical Systems & Equipment Maintenance',
  'Volume 3 — Electrical Systems & Industrial Maintenance',
  'Volume 4 — Preventive & Predictive Maintenance',
  'Volume 5 — Hydraulic & Pneumatic Systems Maintenance',
  'Volume 6 — Industrial Equipment Reliability & Failure Analysis',
  'Volume 7 — Maintenance Planning, Scheduling & Work Management',
  'Volume 8 — Maintenance Safety, Risk Management & Best Practices',
  'Volume 9 — Teaching Industrial Maintenance',
  'Bonus 1 — 150 Classroom Activities & Challenges',
  'Bonus 2 — Industrial Maintenance Assessment Bank',
  'Bonus 3 — 100 Case Studies & Problem-Solving Scenarios',
  'Bonus 4 — Troubleshooting & Diagnostic Reasoning Guide',
  'Bonus 5 — Industrial Maintenance Concept & Terminology Guide: 200 Essential Concepts',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex industrial maintenance concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see industrial maintenance's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
